import { useState } from 'react'
import type { JSX } from 'react'

import { Dialog, useIsMobileScreenSize } from '@buffer-mono/popcorn'

import { PlanSelector } from './PlanSelector'
import type { PlanSelectorProps } from './PlanSelector'

import styles from './PlanSelectorDialog.module.css'

export interface PlanSelectorDialogProps extends PlanSelectorProps {
  onClose?: () => void
}

export function PlanSelectorDialog(
  props: PlanSelectorDialogProps,
): JSX.Element {
  const [open, setOpen] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const isMobile = useIsMobileScreenSize()

  const handleOpenChange = (open: boolean): void => {
    setOpen(open)
    if (!open) {
      props.onClose?.()
    }
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <Dialog.Content
        className={styles.dialogContent}
        size={isMobile ? 'maximize' : undefined}
      >
        <div className={styles.innerContent}>
          <Dialog.CloseButton disabled={isLoading} />
          <Dialog.Title size="xl">Change your Plan</Dialog.Title>
          <PlanSelector {...props} onLoadingChange={setIsLoading} />
        </div>
      </Dialog.Content>
    </Dialog>
  )
}
